var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{staticClass:"create_but",attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.login_show_but}},[_vm._v(_vm._s(_vm.loading?'生成中...':'生成内容'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }